"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromSideBySide = void 0;
var SideBySide_1 = require("ContentTokens/Models/SideBySide");
var getColumns = function (token) {
    var column1 = token.column1, column2 = token.column2;
    if (token.order) {
        return token.order === SideBySide_1.SideBySideOrder.Normal ? [column1, column2] : [column2, column1];
    }
    return [column1, column2];
};
var createHtmlFromSideBySide = function (token, options) {
    var percent = token.percent || SideBySide_1.SideBySideColumnSize.OneHalf;
    var width = token.width || SideBySide_1.SideBySideWidth.Wide;
    var alignment = token.alignment || SideBySide_1.SideBySideAlignment.Normal;
    var _a = __read(getColumns(token), 2), leftColumn = _a[0], rightColumn = _a[1];
    var leftColumnOptions = __assign(__assign({}, options), { sideBySide: {
            withinSideBySide: true,
            columnWidthPercent: percent,
        } });
    var rightColumnOptions = __assign(__assign({}, options), { sideBySide: {
            withinSideBySide: true,
            columnWidthPercent: 100 - percent,
        } });
    var leftPercentageClass = getPercentageClass(percent);
    var rightPercentageClass = getPercentageClass(100 - percent);
    return [
        "<div class=\"side-by-side__wrapper\">",
        "<div class=\"side-by-side side-by-side--".concat(width, " side-by-side--").concat(alignment, "\">"),
        "  <div class=\"side-by-side__col side-by-side__col--left ".concat(leftPercentageClass, "\">"),
        "    ".concat(options.renderTokens(leftColumn, leftColumnOptions)),
        "  </div>",
        "  <div class=\"side-by-side__col side-by-side__col--right ".concat(rightPercentageClass, "\">"),
        "    ".concat(options.renderTokens(rightColumn, rightColumnOptions)),
        "  </div>",
        "</div>",
        "</div>",
    ].join("");
};
exports.createHtmlFromSideBySide = createHtmlFromSideBySide;
var getPercentageClass = function (percentage) {
    if (percentage === SideBySide_1.SideBySideColumnSize.OneQuarter) {
        return "side-by-side__col--one-quarter";
    }
    if (percentage === SideBySide_1.SideBySideColumnSize.OneHalf) {
        return "side-by-side__col--one-half";
    }
    if (percentage === SideBySide_1.SideBySideColumnSize.ThreeQuarters) {
        return "side-by-side__col--three-quarter";
    }
};
